
import {map, filter} from 'rxjs/operators';
 import { Component, Input, OnInit } from '@angular/core';

import { Observable ,  BehaviorSubject } from 'rxjs';

import { LunaDomain } from '../../../../../models/domain.model';
import { DomainDefinitionService } from '../../../../../services/domain-definition.service';
import { BaseControlComponent } from '../../../../../../form-controls/components/base-control/base-control.component';
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';


@Component({
    selector: 'app-multiselect-data-config',
    templateUrl: './multiselect-data-config.component.html',
    styleUrls: ['./multiselect-data-config.component.scss'],
    standalone: false
})
export class MultiselectDataConfigComponent extends BaseControlComponent implements OnInit {

  static componentName = 'MultiselectDataConfigComponent';

  public domains: Observable<LunaDomain[]>;
  public domainProperties: Observable<Array<string>>;
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(public _domainService: DomainDefinitionService, public readonly contextService: ContextInteractionService) {
    super(contextService);
    this.domains = this._domainService.getAll();
  }

  ngOnInit() {
    if(!this.componentData.config.customSource){
      this.componentData.config.customSource = {
        enabled:false,
        path:"",
        idProperty:"",
        displayProperty:""
      }
    }
    this.isLoading$.next(true);
    this.domains.subscribe(
      data => { },
      error => { },
      () => { this.isLoading$.next(false); });

    this.fetchDomainValues();
  }

  public fetchDomainValues(): void {
    this.domainProperties = this._domainService.get(this.componentData.config.domain).pipe(
    filter(x=>Array.isArray(x.values)),
    map(x => this.getPropertiesForDomain(x)),);
  }

  public getPropertiesForDomain(domain: LunaDomain): Array<string> {

    if (!domain)
      return undefined;

    let key = domain.values[Object.keys(domain.values)[0]];

    return Object.keys(key);
  }
}
